import { useParams, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import EthiccraftAbout from "./Ethiccraft_College_header";
import TestimonialSlider from "./Faculty_Testimonials";
import RecentEvents from "./Recent_Activities";
import "../Css/Colleges_Ethiccraft.css";

import COLLEGE_MAP from "../../constants/colleges";

function EthiccraftCollege() {
  const { collegeCode } = useParams();
  const code = collegeCode.toLowerCase();

  const allowedColleges = Object.keys(COLLEGE_MAP);
  //Whenever add a new college here, also add in Profile Edit & Profile Card

  if (!allowedColleges.includes(code)) {
    return <Navigate to="/" replace />;
  }

  const collegeName = code.toUpperCase();

  return (
    <AnimatePresence>
      <EthiccraftAbout collegeName={collegeName} />
      <TestimonialSlider collegeName={collegeName} />
      <RecentEvents collegeName={collegeName} />
    </AnimatePresence>
  );
}

export default EthiccraftCollege;
